import I18n from "i18n-js";
import React from "react";

export default class AddRemoveCourse extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      course_added: this.props.course_added || false,
    };

    this.addToMyCourses = this.addToMyCourses.bind(this);
    this.confirmRemoveFromMyCourses =
      this.confirmRemoveFromMyCourses.bind(this);
    this.removeFromMyCourses = this.removeFromMyCourses.bind(this);
  }

  render() {
    if (this.props.uid) {
      if (this.state.course_added) {
        return (
          <div className="add-remove-course">
            <a href="#" onClick={this.confirmRemoveFromMyCourses}>
              {I18n.t("remove_from_my_courses")}{" "}
              <span className="fa fa-minus-circle">&nbsp;</span>
            </a>
          </div>
        );
      } else {
        return (
          <div className="add-remove-course">
            <a
              href="#"
              onClick={this.addToMyCourses}
              aria-label={I18n.t("course_name_add_to_my_courses", {
                name: this.props.name,
              })}
            >
              {I18n.t("add_to_my_courses")}{" "}
              <span className="fa fa-plus-circle">&nbsp;</span>
            </a>
          </div>
        );
      }
    } else {
      return (
        <div className="add-remove-course" style={{ height: 1 }}>
          &nbsp;
        </div>
      );
    }
  }

  addToMyCourses(e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ course_added: true });

    $.ajax({
      type: "POST",
      url: this.props.add_to_my_courses_path,
      data: {
        course_id: this.props.course_id,
        course_collection_id: this.props.course_collection_id,
        course_level_id: this.props.course_level_id,
      },
    }).done(function (data) {
      //console.log('addToMyCourses done', data);
    });
  }

  confirmRemoveFromMyCourses(e) {
    e.preventDefault();
    e.stopPropagation();

    var confirmed = confirm(I18n.t("remove_from_my_courses_confirmation"));

    if (confirmed) {
      this.removeFromMyCourses(e);
      this.setState({ course_added: false });
    }
  }

  removeFromMyCourses(e) {
    e.preventDefault();
    e.stopPropagation();

    $.ajax({
      type: "POST",
      url: this.props.remove_from_my_courses_path,
      data: {
        course_id: this.props.course_id,
      },
    }).done(function (data) {
      //console.log('removeFromMyCourses done', data);
    });
  }
}
